// eslint-disable-next-line no-restricted-imports
import { type LDClient } from "launchdarkly-js-client-sdk";

import { getAppInfo } from "../lib/utils/capacitor/deviceUtils";
import { type Worker } from "../Worker/api/types";
import { type WorkerDocumentsByStatus } from "../Worker/useWorkerDocumentsByStatus";
import { getAnonymousLdUser, getSignedInLdUser } from "./cbhUserContext";

interface IdentifyUserParams {
  inputForContext: {
    worker: Worker | undefined;
    documentsByStatus: WorkerDocumentsByStatus;
  };
  client: LDClient;
}
export const identifyUser = async (params: IdentifyUserParams) => {
  const { inputForContext, client } = params;
  const cbhAppInfo = await getAppInfo();

  const ldUser = inputForContext.worker?.userId
    ? getSignedInLdUser(cbhAppInfo, {
        userId: inputForContext.worker?.userId ?? "",
        name: inputForContext.worker?.name ?? "",
        email: inputForContext.worker?.email ?? "",
        stage: inputForContext.worker?.stage ?? "",
        msa: inputForContext.worker?.address?.metropolitanStatisticalArea ?? "",
        city: inputForContext.worker?.address?.city ?? "",
        state: inputForContext.worker?.address?.state ?? "",
        stateCode: inputForContext.worker?.address?.stateCode ?? "",
        countryCode: inputForContext.worker?.address?.countryCode ?? "",
        qualification: inputForContext.worker?.preference?.qualification ?? "",
        createdAt: inputForContext.worker?.createdAt ?? "",
        qualifications:
          inputForContext.worker?.licensesData?.map((item) => item.qualification) ?? [],
        homeHealthEnabled: inputForContext.worker?.homeHealthEnabled ?? false,
        ...inputForContext.documentsByStatus,
      })
    : getAnonymousLdUser(cbhAppInfo);

  await client.identify(ldUser);
};
